import { Breakpoints, BreakpointsWithPx } from "./../../breakpoints";

class SwiperInstances {
  constructor() {
    this.init();
  }

  init() {
    const getNavigation = (container) => ({
      clickable: true,
      disabledClass: 'disabled !hidden',
      prevEl: container.querySelector(`.swiper-controls__prev`),
      nextEl: container.querySelector(`.swiper-controls__next`),
    });

    const get3ColSliderGrid = () => ({
      slidesPerView: 1,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        [Breakpoints.sm]: {
          slidesPerView: 2,
        },
        [Breakpoints.lg]: {
          slidesPerView: 3,
        },
      },
    });

    const get4ColSliderGrid = () => ({
      slidesPerView: 1,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        [Breakpoints.sm]: {
          slidesPerView: 2,
        },
        [Breakpoints.md]: {
          slidesPerView: 3,
        },
        [Breakpoints.lg]: {
          slidesPerView: 4,
        },
      },
    });

    // Swiper's screen reader labels default to English.
    const a11yMessages = window.Drupal ? {
      prevSlideMessage: Drupal.t('Previous slide'),
      nextSlideMessage: Drupal.t('Next slide'),
      firstSlideMessage: Drupal.t('This is the first slide'),
      lastSlideMessage: Drupal.t('This is the last slide'),
      paginationBulletMessage: Drupal.t('Go to slide @index', { '@index': '{{index}}' }),
    } : {};

    const addSwiperConfig = (container, config) => {
      const gallery = container.querySelector("swiper-container");

      if (!gallery) return;

      Object.assign(gallery, config);
    };

    const initializeGalleryComponent = () => {

      const isBelowSm = !window.matchMedia(`(min-width: ${BreakpointsWithPx.sm})`).matches;
      const isAboveMd = window.matchMedia(`(min-width: ${BreakpointsWithPx.md})`).matches;

      // Testimonials gallery.
      document.querySelectorAll(`.testimonial-slider`)
        .forEach((swiperContainer) => {

          addSwiperConfig(swiperContainer, {
            slidesPerView: 1,
            breakpoints: {
              [Breakpoints.md]: {
                slidesPerView: 2
              },
            },
            navigation: {
              ...getNavigation(swiperContainer)
            },
            // auto height on mobile.
            autoHeight: isBelowSm,
          });
      });

      // News releases slider.
      // Stories slider.
      // Related stories slider.
      // Related resources slider.
      // Product stories slider (UK product family pages).
      document.querySelectorAll(`.view-id-news_releases, .view-id-featured_stories, .view-id-related_stories, .related-resources-slider, .view-id-case_studies, .view-id-product_stories, .block-views-blockmore-case-studies-block-1`)
        .forEach((swiperContainer) =>
          addSwiperConfig(swiperContainer, {
            ...get3ColSliderGrid(),
            navigation: {
              ...getNavigation(swiperContainer)
            },
            a11y: true,
            autoHeight: isBelowSm,
          })
      );

      // Resource block slider - uses dynamic slides-per-view from HTML attribute.
      document.querySelectorAll(`.resources-block-slider`)
        .forEach((swiperContainer) => {
          const gallery = swiperContainer.querySelector("swiper-container");
          const slidesPerView = gallery ? parseInt(gallery.getAttribute('slides-per-view')) || 3 : 3;

          addSwiperConfig(swiperContainer, {
            slidesPerView: 1,
            breakpoints: {
              0: {
                slidesPerView: 1,
              },
              [Breakpoints.sm]: {
                slidesPerView: Math.min(2, slidesPerView),
              },
              [Breakpoints.lg]: {
                slidesPerView: slidesPerView,
              },
            },
            navigation: {
              ...getNavigation(swiperContainer)
            },
            a11y: true,
          })
        }
      );

      // Content carousel.
      document.querySelectorAll(`.content-carousel, .view-id-jobs_list`)
        .forEach((swiperContainer) => {
          addSwiperConfig(swiperContainer, {
            ...get4ColSliderGrid(),
            navigation: {
              ...getNavigation(swiperContainer)
            },
          })

          // If eyebrows exist, add a class
          // if (swiperContainer.querySelector('.eyebrow')) {
          //   swiperContainer.classList.add('quick-facts-have-eyebrows');
          // }
        }
      );

      // Mosaic slider vertical thumbs: set direction based on viewport.
      document.querySelectorAll('.mosaic-slider-gallery--vertical .mosaic-slider-thumbs--vertical[init="false"]').forEach((thumbsEl) => {
        var isVertical = isAboveMd;
        var config = { direction: isVertical ? 'vertical' : 'horizontal' };
        // Enable mouse-wheel scrolling on the vertical rail so thumbnails beyond
        // the visible column height are reachable. releaseOnEdges hands scrolling
        // back to the page at the top/bottom (never traps the page), and
        // forceToAxis ignores horizontal wheel motion.
        if (isVertical) {
          config.mousewheel = { enabled: true, releaseOnEdges: true, forceToAxis: true };
        }
        Object.assign(thumbsEl, config);
        thumbsEl.initialize();
        thumbsEl.setAttribute('init', 'true');
      });

      // Mosaic slider external navigation: wire up prev/next buttons and move into block title.
      document.querySelectorAll('.mosaic-slider-gallery').forEach((gallery) => {
        const nav = gallery.querySelector('.mosaic-slider-nav');
        if (!nav) return;

        // Move nav into the block title so it appears on the same row.
        const block = gallery.closest('.block');
        if (block) {
          const blockTitle = block.querySelector('.block-title');
          if (blockTitle) {
            blockTitle.appendChild(nav);
          }
        }

        const prevBtn = nav.querySelector('.mosaic-slider-nav__prev');
        const nextBtn = nav.querySelector('.mosaic-slider-nav__next');
        if (!prevBtn || !nextBtn) return;
        const mainSwiper = gallery.querySelector('.mosaic-slider-main');
        if (!mainSwiper) return;

        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          mainSwiper.swiper.slidePrev();
        });
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          mainSwiper.swiper.slideNext();
        });
      });

      // Lastly, initialize all galleries, once options are in.
      document.querySelectorAll('swiper-container[init="false"]').forEach((slider) => {
        slider.a11y = { ...a11yMessages, ...(typeof slider.a11y === 'object' ? slider.a11y : {}) };
        slider.initialize();
        slider.setAttribute('init', 'true');
      });

      // Mosaic slider vertical: keep the active thumbnail in view when the main
      // image changes (arrows / keyboard). freeMode on the thumbs suppresses
      // Swiper's built-in thumb-follow, so move the rail ourselves — but only
      // when the active thumb is off-screen, to avoid snapping on direct clicks.
      if (isAboveMd) {
        document.querySelectorAll('.mosaic-slider-gallery--vertical').forEach((gallery) => {
          const mainEl = gallery.querySelector('.mosaic-slider-main');
          const thumbsEl = gallery.querySelector('.mosaic-slider-thumbs--vertical');
          if (!mainEl || !thumbsEl || !mainEl.swiper || !thumbsEl.swiper) return;

          // While the user is dragging the rail, suppress Swiper's automatic
          // re-centering on the active thumbnail. It calls slideTo() on every
          // drag move, which yanks the rail back toward the active thumb and
          // makes dragging away from it jump instead of scroll smoothly. Our own
          // navigation follow (below) runs on the main slider's slideChange, not
          // during a thumb drag, so it keeps working.
          let thumbDragging = false;
          thumbsEl.swiper.on('touchStart', () => { thumbDragging = true; });
          thumbsEl.swiper.on('touchEnd', () => { thumbDragging = false; });
          const nativeThumbSlideTo = thumbsEl.swiper.slideTo.bind(thumbsEl.swiper);
          thumbsEl.swiper.slideTo = function (...args) {
            if (thumbDragging) return thumbsEl.swiper;
            return nativeThumbSlideTo(...args);
          };

          mainEl.swiper.on('slideChange', () => {
            const thumbs = thumbsEl.swiper;
            const index = mainEl.swiper.activeIndex;
            const slide = thumbs.slides[index];
            if (!slide) return;
            const railRect = thumbs.el.getBoundingClientRect();
            const slideRect = slide.getBoundingClientRect();
            const fullyVisible = slideRect.top >= railRect.top - 1 && slideRect.bottom <= railRect.bottom + 1;
            if (!fullyVisible) {
              thumbs.slideTo(index);
            }
          });

          // Fade the rail edge(s) that have hidden thumbnails, so it's clear the
          // rail scrolls. Toggle classes from the current scroll position;
          // computed from translate so it works in freeMode / on wheel + drag.
          const updateThumbFade = () => {
            const sw = thumbsEl.swiper;
            const scrollable = (sw.minTranslate() - sw.maxTranslate()) > 1;
            thumbsEl.classList.toggle('can-scroll-up', scrollable && sw.translate < sw.minTranslate() - 1);
            thumbsEl.classList.toggle('can-scroll-down', scrollable && sw.translate > sw.maxTranslate() + 1);
          };
          thumbsEl.swiper.on('setTranslate', updateThumbFade);
          thumbsEl.swiper.on('resize', updateThumbFade);
          thumbsEl.swiper.on('update', updateThumbFade);
          updateThumbFade();
        });
      }

      // Swiper issue: https://github.com/nolimits4web/swiper/issues/7528
      // Remove invalid aria controls until supported.
      document.querySelectorAll('.swiper-controls__prev, .swiper-controls__next').forEach((control) => {
        control.removeAttribute('aria-controls');
      });
    };

    document.addEventListener("DOMContentLoaded", () => {
      initializeGalleryComponent();
    });
  }
}

export {
  SwiperInstances
};
